import { landingConfig } from './config/landingConfig.js';

function normalizeFaq(faq) {
  return {
    question: faq.question || faq.q || '',
    answer: faq.answer || faq.a || '',
  };
}

function createExtraFaqCard(faq, index) {
  const wrapper = document.createElement('div');
  wrapper.dataset.extraStatementSyncFaq = String(index);
  wrapper.className = 'overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-6';
  button.setAttribute('aria-expanded', 'false');

  const question = document.createElement('span');
  question.className = 'font-bold text-slate-950';
  question.textContent = faq.question;

  const chevron = document.createElement('span');
  chevron.setAttribute('aria-hidden', 'true');
  chevron.className = 'shrink-0 text-xl leading-none text-slate-400 transition-transform';
  chevron.textContent = '⌄';

  const answer = document.createElement('div');
  answer.hidden = true;
  answer.className = 'border-t border-slate-100 px-5 py-5 text-sm leading-7 text-slate-600 sm:px-6';
  answer.textContent = faq.answer;

  button.addEventListener('click', () => {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isOpen));
    answer.hidden = isOpen;
    chevron.style.transform = isOpen ? '' : 'rotate(180deg)';
  });

  button.append(question, chevron);
  wrapper.append(button, answer);
  return wrapper;
}

function appendExtraFaqs() {
  const faqSection = document.getElementById('faq');
  if (!faqSection) return;

  const list = faqSection.querySelector('.space-y-3');
  if (!list || list.querySelector('[data-extra-statement-sync-faq]')) return;

  (landingConfig.faqItems || [])
    .map(normalizeFaq)
    .slice(8)
    .forEach((faq, index) => {
      if (faq.question && faq.answer) list.appendChild(createExtraFaqCard(faq, index));
    });
}

function refreshVisibleModifiedDate() {
  const time = document.querySelector('time[datetime="2026-09-14"]');
  if (!time) return;
  time.setAttribute('datetime', '2026-09-15');
  time.textContent = '15 September 2026';
}

export function startContentEnhancements() {
  const render = () => {
    appendExtraFaqs();
    refreshVisibleModifiedDate();
  };

  const observer = new MutationObserver(render);
  observer.observe(document.body, { childList: true, subtree: true });
  requestAnimationFrame(render);

  return () => observer.disconnect();
}